import { __assign } from 'tslib';
import React__default from 'react';
import classNames from 'classnames';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import NvVideo from '../NvVideo/NvVideo.esm.js';
import NvVimeo from '../Vimeo/Vimeo.esm.js';
import styles from './VideoPage.module.esm.js';

var VideoPage = function (props) {
    var heading = props.heading, body = props.body, vimeoId = props.vimeoId;
    return (React__default.createElement("div", { className: classNames('nv-container', styles.container, !vimeoId && styles.videojsContainer) },
        vimeoId ? React__default.createElement(NvVimeo, __assign({}, props)) : React__default.createElement(NvVideo, __assign({}, props)),
        heading && (React__default.createElement(NvMarkdownInline, { className: classNames('nv-container', styles.heading), elementWrapper: NvHeading, level: 1 }, heading)),
        body && (React__default.createElement(NvMarkdown, { className: classNames('nv-container nv-subheading-1-book', styles.subheading) }, body))));
};

export { VideoPage as default };
//# sourceMappingURL=VideoPage.esm.js.map
